import { BaseModel } from "./hateoas/base-model";

export class ReportingRuleModel extends BaseModel {
  reportTypeUuid?: string;
  reportingRuleUuid?: string;
  value?: number;
}
